import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { viewVideoGallery } from "../../store/actions/adminActions/addGallery";
import {
  getGalleryAlbums,
  getGalleryYears,
} from "../../store/actions/councilActions/galleryAlbumAction";
import Loader from "../Alert/Loader";
import Lightbox from "./Lightbox";
import "./css/gallery.css";

const VideoGallery = () => {
  const [videos, setVideos] = useState(null);
  // Which video the popup is showing; null = popup closed.
  const [lbIndex, setLbIndex] = useState(null);
  // Which album is being shown. "" is every video, as before.
  const [album, setAlbum] = useState("");
  const [albums, setAlbums] = useState([]);
  const [year, setYear] = useState("");
  const [years, setYears] = useState([]);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getGalleryAlbums({ active: 1, type: "video" })).then((list) =>
      setAlbums((list || []).filter((a) => a.items_count > 0))
    );
    dispatch(getGalleryYears("video")).then(setYears);
  }, [dispatch]);

  useEffect(async () => {
    setVideos(null);
    const response = await dispatch(viewVideoGallery(album, year));
    // admin/gallery/video always paginates, so the payload is a paginator
    // object ({current_page, data: [...]}) - the same shape Gallery.js reads
    // as response.data.data. On the error path the action returns a plain [].
    const list = Array.isArray(response.data)
      ? response.data
      : Array.isArray(response.data?.data)
      ? response.data.data
      : [];
    setVideos(list);
  }, [album, year]);
  var regExp =
    /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;

  // Pull the 11-char YouTube id out of whatever URL shape was saved.
  const ytId = (url) => {
    const m = (url || "").match(regExp);
    return m && m[2] && m[2].length === 11 ? m[2] : "";
  };

  return (
    <div>
      <div className="gallery-box">
        <div className="container">
          <div className="title-box">
            <h4>Video Gallery</h4>
          </div>

          {years.length > 0 && (
            <div className="album-filter">
              <button
                type="button"
                className={`album-chip ${year === "" ? "active" : ""}`}
                onClick={() => setYear("")}
              >
                All Years
              </button>
              {years.map((y) => (
                <button
                  type="button"
                  key={y}
                  className={`album-chip ${
                    String(year) === String(y) ? "active" : ""
                  }`}
                  onClick={() => setYear(y)}
                >
                  {y}
                </button>
              ))}
            </div>
          )}

          {albums.length > 0 && (
            <div className="album-filter">
              <button
                type="button"
                className={`album-chip ${album === "" ? "active" : ""}`}
                onClick={() => setAlbum("")}
              >
                All
              </button>
              {albums.map((a) => (
                <button
                  type="button"
                  key={a.id}
                  className={`album-chip ${String(album) === String(a.id) ? "active" : ""}`}
                  onClick={() => setAlbum(a.id)}
                >
                  {a.name} <span>({a.items_count})</span>
                </button>
              ))}
            </div>
          )}
          <div className="row">
            {videos == null ? (
              <Loader active={true} />
            ) : videos.length > 0 ? (
              videos.map((video, index) => (
                <div className="col-lg-4 col-md-6 col-sm-12 mb-4" key={video.id}>
                  <div
                    className="galleryBox videoBox"
                    onClick={() => setLbIndex(index)}
                  >
                    <div className="videoThumb">
                      <img
                        src={`https://img.youtube.com/vi/${ytId(
                          video.video_url
                        )}/hqdefault.jpg`}
                        alt={video.title}
                      />
                      <span className="videoPlay">&#9658;</span>
                    </div>
                    <h6 className="text-center">{video.title}</h6>
                  </div>
                </div>
              ))
            ) : (
              <h1>No Gallery found</h1>
            )}
          </div>

          {lbIndex !== null && videos && videos.length > 0 && (
            <Lightbox
              items={videos.map((v) => ({
                type: "video",
                src: `https://www.youtube.com/embed/${ytId(
                  v.video_url
                )}?autoplay=1&rel=0`,
                title: v.title,
              }))}
              index={lbIndex}
              onClose={() => setLbIndex(null)}
              onNav={setLbIndex}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default VideoGallery;
